import React, { useEffect, useState } from "react";
import ChatSection from "./ChatSection/ChatSection";
import ParticipantsSection from "./ParticipantsSection/ParticipantsSection";
import VideoSection from "./VideoSection/VideoSection";
import RoomLabel from "./RoomLabel";
import { connect } from "react-redux";
import * as webRTCHandler from "../utils/webRTCHandler";
import Overlay from "./Overlay";
import VideoButtons from "./VideoSection/VideoButtons";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import "./RoomPage.css";

const RoomPage = ({
  roomId,
  identity,
  isRoomHost,
  showOverlay,
  connectOnlyWithAudio,
}) => {
  const [localStream, setLocalStream] = useState(null);
  const [remoteStreams, setRemoteStreams] = useState([]);
  const [showChatPopup, setShowChatPopup] = useState(false);

  useEffect(() => {
    if (!isRoomHost && !roomId) {
      const siteUrl = window.location.origin;
      window.location.href = siteUrl;
    } else {
      webRTCHandler.getLocalPreviewAndInitRoomConnection(
        isRoomHost,
        identity,
        roomId,
        connectOnlyWithAudio
      );
    }
    const waitForStream = setInterval(() => {
      const stream = webRTCHandler.getLocalStream();
      const streams = webRTCHandler.getRemoteStreams();
      setRemoteStreams(streams || []);

      if (stream) {
        setLocalStream(stream);
        clearInterval(waitForStream);
      }
    }, 1);

    return () => clearInterval(waitForStream);
  }, []);

  const handleOpenChat = () => {
    setShowChatPopup(true); // Show chat popup
  };

  const handleCloseChat = () => {
    setShowChatPopup(false); // Close chat popup
  };

  return (
    <div className="room_container">
      {/* <ParticipantsSection /> */}
      <VideoSection />
      <VideoButtons
        meetingStream={remoteStreams}
        roomId={roomId}
        isRoomHost={isRoomHost}
        onOpenChat={handleOpenChat} // Pass the handler to VideoButtons
      />
      <RoomLabel roomId={roomId} />
      {showOverlay && <Overlay />}

      {/* Modal for Chat Section */}
      <Modal
        show={showChatPopup}
        onHide={handleCloseChat}
        size="lg"
        className="modal-top-spacing"
      >
        <Modal.Header closeButton>
          <Modal.Title>Talk Zone</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ChatSection />
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStoreStateToProps)(RoomPage);
